var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverItemCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1223_729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6113 39.2663C31.3378 39.2663 39.2226 31.3815 39.2226 21.655C39.2226 11.9286 31.3378 4.0437 21.6113 4.0437C11.8849 4.0437 4 11.9286 4 21.655C4 31.3815 11.8849 39.2663 21.6113 39.2663ZM14.5111 17.5892C14.0217 16.9524 13.1088 16.833 12.472 17.3224C11.8353 17.8118 11.7158 18.7247 12.2052 19.3614L20.4581 30.0994C20.7334 30.4575 21.1594 30.6674 21.611 30.6674C22.0627 30.6674 22.4887 30.4575 22.764 30.0994L31.0169 19.3615C31.5063 18.7247 31.3868 17.8118 30.7501 17.3224C30.1133 16.833 29.2004 16.9525 28.711 17.5892L21.6111 26.827L14.5111 17.5892Z",
    fill: "#FFB600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1223_729",
    x: 0,
    y: 0.0437012,
    width: 43.2227,
    height: 43.2227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1223_729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1223_729",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverItemCheck);
export default __webpack_public_path__ + "static/media/hover_item_check.62af8d1908d9c55708530223c0c5261d.svg";
export { ForwardRef as ReactComponent };